export const commercialDecisionWarningForState = (commercialState, translate) => {
	if (!commercialState || commercialState.canEditSelection || commercialState.selectionLocked) return null;
	return translate('agreement-package-offer.decision-signer-required', {
		name: commercialState.decisionSignerName || translate('agreement-package-offer.decision-signer-fallback'),
	});
};

export const commercialDecisionWarning = (agreement, translate) => {
	const offer = (agreement.pages || [])
		.flatMap((page) => page.schema || [])
		.find((item) => item.type === 'PackageOffer' && item.commercialState);
	return commercialDecisionWarningForState(offer && offer.commercialState, translate);
};
